import React, { useState } from 'react';
import api from '../lib/api';
import { useNavigate, Link, useLocation } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as any)?.from;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', response.data.token);
      if (typeof redirectTo === 'string') {
        navigate(redirectTo);
      } else if (redirectTo?.pathname) {
        navigate(`${redirectTo.pathname}${redirectTo.search || ''}`);
      } else {
        navigate('/wallet');
      }
    } catch (error: any) {
      console.error(error);
      setError(error.response?.data?.error || 'Přihlášení se nezdařilo. Zkuste to znovu.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative w-full max-w-md animate-fade-in">
        <div className="bg-white/80 backdrop-blur-lg p-8 sm:p-10 space-y-6 sm:space-y-8 rounded-3xl shadow-card-hover border border-white">
          <div className="text-center">
            <div className="text-6xl mb-4 animate-bounce-slow">🎮</div>
            <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent">
              Vítejte zpět!
            </h2>
            <p className="mt-2 text-gray-600">Přihlaste se a pokračujte ve hře</p>
          </div>

          {error && (
            <div className="p-4 text-sm text-red-700 bg-red-50 rounded-2xl border border-red-200 animate-slide-up">
              <span className="mr-2">⚠️</span>
              {error}
            </div>
          )}

          <form className="space-y-5 sm:space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                📧 E-mailová adresa
              </label>
              <input
                type="email"
                required
                className="w-full p-4 text-gray-900 bg-white rounded-2xl border-2 border-gray-200 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100 transition-all duration-300"
                placeholder="uzivatel@email.cz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                🔒 Heslo
              </label>
              <input
                type="password"
                required
                className="w-full p-4 text-gray-900 bg-white rounded-2xl border-2 border-gray-200 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100 transition-all duration-300"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full py-4 font-bold text-white bg-gradient-to-r from-primary-500 to-secondary-500 rounded-2xl shadow-lg hover:shadow-glow hover:scale-105 transform transition-all duration-300"
            >
              Přihlásit se 🚀
            </button>
          </form>

          <div className="text-center">
            <p className="text-gray-600">
              Nemáte účet?{' '}
              <Link
                to="/register"
                state={location.state}
                className="font-bold text-primary-600 hover:text-secondary-600 transition-colors"
              >
                Zaregistrujte se zde
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-primary-600 hover:text-secondary-600 font-semibold transition-colors">
            ← Zpět na úvod
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
